import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { withAuctionCore } from 'agent';
import useLocalStorage from 'hooks/useLocalStorage';
import { Route, Redirect, useLocation } from 'react-router-dom';
import useStores from 'hooks/useStore';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ProtectedRoute = ({ component: Component, auctioncore, ...rest }) => {
  const { UserStore } = useStores();
  const [token, setToken] = useLocalStorage('token', '');

  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const query = useQuery();

  const asyncAuth = async () => {
    let qsToken = query.get('token');
    const qsReferrer = query.get('referrer') || document.referrer;

    if (qsReferrer && !qsToken) {
      try {
        const response = await auctioncore.doSignIn(null, null, qsReferrer);
        setToken(response.data.sessionToken);
        qsToken = response.data.sessionToken;
        UserStore.setToken(response.data.sessionToken);
        setIsAuthenticated(true);
      } catch (e) {

      }
    }

    if (!token && !qsToken) {
      setIsLoading(false);
      return;
    }

    if (qsToken) {
      setToken(qsToken);
    }

    const _token = qsToken || token;
    auctioncore.authSession(_token)
      .then((response) => {
        if (response.data.isValid) {
          UserStore.setToken(_token);
          setIsAuthenticated(true);
          return;
        }
        setToken(null);
      })
      .catch(() => {
        setIsAuthenticated(false);
        setToken(null);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    asyncAuth();
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: '/login',
            }}
          />
        );
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  auctioncore: PropTypes.object.isRequired,
  component: PropTypes.node.isRequired,
};

export default withAuctionCore(observer(ProtectedRoute));
